<div class="container container-custom">
    <div class="row align-items-center">
        <div class="col-xl-12">
            <ng-container *ngIf="!isLoading else loading">
                <ng-container *ngIf="isExpired">
                    <div class="card min_height">
                        <div class="col-lg-12 p-4 session-page">
    
                            <div class="d-flex justify-content-center">
                                <img src="images/session_timeout.png">
                            </div>
    
                            <div class="text-center session-page-content">
                                <p class="f-20 m-0 f-w-400 mb-4">Your payment link has expired. Please try to contact the
                                    practice administrator.</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        <!-- <div class="col-xl-4 text-center d-none d-md-block ">
            <img src="images/payment-amount.png" class="img-fluid">
        </div> -->
    </div>
    <ng-template #loading>
        <div class="card">
            <app-card-skeletal [rows]="1" [cardsPerRow]="1" [cardHeight]="140"></app-card-skeletal>
        </div>
        <div class="card">
            <div class="row">
                <div class="col-md-4 d-none d-md-block">
                    <app-card-skeletal [rows]="1" [cardsPerRow]="1" [cardHeight]="310"></app-card-skeletal>
                </div>
                <div class="col-md-8">
                    <app-card-skeletal [rows]="5" [cardsPerRow]="1" [cardHeight]="50"></app-card-skeletal>
                </div>
            </div>
        </div>
    </ng-template>
</div>
